import axios from "axios";
import { toast } from "react-toastify";
import {
  clearAuthSession,
  isSessionExpiredMessage,
  isSessionExpiredPayload,
  SESSION_EXPIRED_MESSAGE_AR,
} from "./authStorage";

let handlingSessionExpiry = false;

export function handleSessionExpired(message = SESSION_EXPIRED_MESSAGE_AR) {
  if (handlingSessionExpiry) return;
  handlingSessionExpiry = true;
   
  const displayMessage =
    typeof message === "string" && message.trim()
      ? message.trim()
      : SESSION_EXPIRED_MESSAGE_AR;

  clearAuthSession();

  toast.error(displayMessage, {
    toastId: "session-expired",
    autoClose: 3000,
  });

  const { pathname } = window.location;
  const isAuthPage =
    pathname === "/login" ||
    pathname === "/verify_code" ||
    pathname === "/reset_password";

  if (!isAuthPage) {
    window.location.replace("/login");
  } else {
    window.setTimeout(() => {
      handlingSessionExpiry = false;
    }, 1500);
  }
}

function extractSessionMessage(source) {
  if (!source) return null;
  if (isSessionExpiredPayload(source)) {
    return typeof source.message === "string" ? source.message : SESSION_EXPIRED_MESSAGE_AR;
  }
  if (isSessionExpiredMessage(source.message)) return source.message;
  if (typeof source === "string" && isSessionExpiredMessage(source)) return source;
  return null;
}

function checkAndHandleSessionExpiry(payload) {
  const message = extractSessionMessage(payload);
  if (!message) return false;
  handleSessionExpired(message);
  return true;
}

export function setupAxiosInterceptors() {
  axios.interceptors.response.use(
    (response) => {
      if (checkAndHandleSessionExpiry(response?.data)) {
        return Promise.reject(
          Object.assign(new Error(SESSION_EXPIRED_MESSAGE_AR), {
            isSessionExpired: true,
            response,
          })
        );
      }
      return response;
    },
    (error) => {
      const data = error?.response?.data;
      if (checkAndHandleSessionExpiry(data)) {
        return Promise.reject(
          Object.assign(error, { isSessionExpired: true })
        );
      }

      const status = error?.response?.status;
      if (status === 401 && !handlingSessionExpiry) {
        const apiMessage = typeof data?.message === "string" ? data.message : "";
        const msg =
          extractSessionMessage(data) ||
          (apiMessage && isSessionExpiredMessage(apiMessage) ? apiMessage : null) ||
          SESSION_EXPIRED_MESSAGE_AR;
        handleSessionExpired(msg);
        return Promise.reject(Object.assign(error, { isSessionExpired: true }));
      }

      return Promise.reject(error);
    }
  );
}

setupAxiosInterceptors();
